import { render, staticRenderFns } from "./Virtualcurrency.vue?vue&type=template&id=525f3703&scoped=true&"
import script from "./Virtualcurrency.vue?vue&type=script&lang=js&"
export * from "./Virtualcurrency.vue?vue&type=script&lang=js&"
import style0 from "./Virtualcurrency.vue?vue&type=style&index=0&id=525f3703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f3703",
  null
  
)

export default component.exports